import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import {
  BackButton,
  Breadcrumbs,
  Text,
  Loading,
  Alert,
  Wrapper,
} from "@networkraildigitalfactory/components";
import styles from "./ViewOneToOne.module.css";
import { InputModal, AreYouSureModal, AccessDeniedModal } from "../Modals";
import ViewOneToOneData from "../ViewOneToOneData/ViewOneToOneData";
import ActionButtons from "./ActionButtons";
import Message from "./Message";
import CreateComment from "../CreateComment/CreateComment";
import CommentList from "../CommentList/CommentList";
import { useOneToOnes, useUsers } from "../../hooks/useAPI";
import StatusLabel from "../StatusLabel/StatusLabel";
import { getEmployeeEmailByPathname } from "../../services/utils";

const ViewOneToOne = (props) => {
  const [{ data: oneToOneData, loading: oneToOnesLoading, error: getError }, getOneToOne] =
    useOneToOnes(props.match.params.id);
  const navTo = (dest) => props.history.push(dest);
  const [isLoading, setLoading] = useState(false);
  const [toggleAccessModal, setToggleAccessModal] = useState(false);
  let isLineManager = localStorage.getItem("isLineManager");

  const { user, isDirtyForm, setIsDirtyForm, setNavModalProps } = props;

  if (isLineManager && oneToOneData && oneToOneData.email !== user.email) {
    isLineManager = true;
  } else {
    isLineManager = false;
  }

  const fetchData = async () => {
    try {
      setLoading(true);
      getOneToOne();
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      setLoading(false);
    }
  };

  const openAccessModal = () => {
    setToggleAccessModal(true);
  };

  const onCloseAccessModal = () => {
    setToggleAccessModal(false);
    navTo("/my-team/");
  };

  const displayAccessModal = (postError) => {
    if (postError && postError.toString().includes("401")) {
      openAccessModal();
    }
  };

  useEffect(() => {
    displayAccessModal(getError);
  }, [getError]);

  const email = getEmployeeEmailByPathname(props.history.location.pathname, "/view-1-2-1");

  const [{ data: employeeBeingViewed }] = useUsers(email);
  let fullName;
  if (employeeBeingViewed) {
    // eslint-disable-next-line prefer-destructuring
    fullName = employeeBeingViewed.fullName;
  }

  const [isInputModalOpen, setIsInputModalOpen] = useState(false);
  const [isAreYouSureModalOpen, setIsAreYouSureModalOpen] = useState(false);
  const [modalAction, setModalAction] = useState("");
  const prepHeading = oneToOneData && oneToOneData.isCompleted ? "1-2-1" : "1-2-1 Prep";

  const toggleInputModal = (action) => {
    setIsInputModalOpen(!isInputModalOpen);
    if (!isInputModalOpen) {
      setModalAction(action);
    }
  };

  const toggleAreYouSureModal = (action) => {
    setIsAreYouSureModalOpen(!isAreYouSureModalOpen);
    if (!isAreYouSureModalOpen) {
      setModalAction(action);
    }
  };

  const onBackClick = () => {
    props.history.push(isLineManager ? `/my-team/${email}/oneToOnes` : "/my-1-2-1s");
  };

  const goToEditView = () => {
    if (isDirtyForm) {
      setNavModalProps({ show: true, navPath: `/edit-1-2-1/${oneToOneData._id}` });
    } else {
      props.history.push(`/edit-1-2-1/${oneToOneData._id}`);
    }
  };

  const goToBeginOneToOneView = () => {
    if (oneToOneData._id) {
      props.history.push(`/my-team/${email}/begin-1-2-1/${oneToOneData._id}`);
    } else {
      props.history.push(
        `/my-team/${email}/begin-1-2-1/${props.match.params.year}/${props.match.params.period}`
      );
    }
  };
  return (
    <>
      <Loading loading={isLoading} />
      <div className={styles.breadcrumbs_wrapper}>
        {!oneToOnesLoading && !isLoading && (
          <Breadcrumbs
            items={
              isLineManager
                ? [
                    {
                      text: "My Team",
                      onClick: () => {
                        if (isDirtyForm) {
                          setNavModalProps({ show: true, navPath: "/my-team" });
                        } else {
                          navTo("/my-team");
                        }
                      },
                    },
                    {
                      text: fullName,
                      onClick: () => {
                        if (isDirtyForm) {
                          setNavModalProps({ show: true, navPath: `/my-team/${email}/oneToOnes` });
                        } else {
                          navTo(`/my-team/${email}/oneToOnes`);
                        }
                      },
                    },
                    { text: "View 1-2-1 notes" },
                  ]
                : [
                    {
                      text: "My 1-2-1s",
                      onClick: () => {
                        if (isDirtyForm) {
                          setNavModalProps({ show: true, navPath: "/my-1-2-1s" });
                        } else {
                          navTo("/my-1-2-1s");
                        }
                      },
                    },
                    { text: "View 1-2-1 notes" },
                  ]
            }
          />
        )}
      </div>
      {((!oneToOnesLoading && !props.match.params.id) ||
        (employeeBeingViewed && oneToOneData && !oneToOneData.prep.isPrepCompleted)) &&
        !getError && (
          <Wrapper maxWidth={1350} align="center">
            <div className={styles.row}>
              <BackButton
                text="back to 1-2-1s"
                onClick={() => {
                  if (isDirtyForm) {
                    setNavModalProps({
                      show: true,
                      navPath: isLineManager ? `/my-team/${email}/oneToOnes` : "/my-1-2-1s",
                    });
                  } else {
                    onBackClick();
                  }
                }}
                style={{ lineHeight: "140%", letterSpacing: "0.0015em" }}
              />
              {oneToOneData.status && (
                <StatusLabel
                  status={
                    oneToOneData.status.charAt(0).toUpperCase() + oneToOneData.status.slice(1)
                  }
                />
              )}
            </div>
            <div className={styles.row} style={{ paddingTop: 0 }}>
              <Message
                status={oneToOneData.status}
                fullName={fullName}
                isLineManager={isLineManager}
              />
            </div>
            <div className={styles.light_bg}>
              <Text
                wrapper="h2"
                type="header"
                style={{ margin: "1.5rem 0", lineHeight: "140%", letterSpacing: "0.0015em" }}
              >
                {oneToOneData.period && `${prepHeading}: Period ${oneToOneData.period}`}
                {props.match.params.period && `${prepHeading}: Period ${props.match.params.period}`}
              </Text>
              {oneToOneData.currentFeedback && (
                <Alert title="Line manager's feedback" message={oneToOneData.currentFeedback} />
              )}
              {!oneToOneData.isCompleted && (
                <Text
                  style={{
                    color: "#000000",
                    fontSize: "18px",
                    lineHeight: "140%",
                    letterSpacing: "0.0015em",
                  }}
                >
                  No prep completed.
                </Text>
              )}
            </div>

            {!oneToOneData.isCompleted && (
              <div className={styles.column}>
                <ActionButtons
                  isLineManager={isLineManager}
                  status="begin-1-2-1"
                  toggleInputModal={toggleInputModal}
                  toggleAreYouSureModal={toggleAreYouSureModal}
                  goToBeginOneToOneView={goToBeginOneToOneView}
                />
                <hr />
              </div>
            )}

            {oneToOneData.isCompleted && (
              <>
                <hr />
                <CreateComment
                  oneToOneId={oneToOneData._id}
                  user={props.user}
                  isLineManager={isLineManager}
                  getUpdatedOneToOne={fetchData}
                  type="oneToOne"
                  setIsDirtyForm={setIsDirtyForm}
                />
                <CommentList
                  data={oneToOneData.comments}
                  user={user}
                  isLineManager={isLineManager}
                  type="comment"
                />
              </>
            )}
          </Wrapper>
        )}
      {!oneToOnesLoading &&
        !isLoading &&
        props.match.params.id &&
        !(employeeBeingViewed && oneToOneData && !oneToOneData.prep.isPrepCompleted) &&
        !getError && (
          <>
            <Wrapper maxWidth={1350} align="center">
              <div className={styles.row}>
                <BackButton
                  text="back to 1-2-1s"
                  onClick={onBackClick}
                  style={{ lineHeight: "140%", letterSpacing: "0.0015em" }}
                />
                <StatusLabel
                  status={
                    oneToOneData.status.charAt(0).toUpperCase() + oneToOneData.status.slice(1)
                  }
                />
              </div>
              <div className={styles.row} style={{ paddingTop: 0 }}>
                <Message
                  status={oneToOneData.status}
                  fullName={fullName}
                  isLineManager={isLineManager}
                />
              </div>
              <div className={styles.light_bg}>
                <Text
                  wrapper="h2"
                  type="header"
                  style={{ margin: "1.5rem 0", lineHeight: "140%", letterSpacing: "0.0015em" }}
                >
                  {oneToOneData.period && `${prepHeading}: Period ${oneToOneData.period}`}
                  {props.match.params.period &&
                    `${prepHeading}: Period ${props.match.params.period}`}
                </Text>
                <ViewOneToOneData
                  data={oneToOneData}
                  isLineManager={isLineManager}
                  user={user}
                  employeeBeingViewed={isLineManager ? employeeBeingViewed : null}
                />
              </div>
              <div className={styles.column}>
                <ActionButtons
                  isLineManager={isLineManager}
                  status={oneToOneData.status}
                  toggleInputModal={toggleInputModal}
                  toggleAreYouSureModal={toggleAreYouSureModal}
                  goToEditView={goToEditView}
                  goToBeginOneToOneView={goToBeginOneToOneView}
                />
                <hr />
              </div>
              {oneToOneData.isCompleted && (
                <>
                  <CreateComment
                    oneToOneId={oneToOneData._id}
                    user={props.user}
                    isLineManager={isLineManager}
                    getUpdatedOneToOne={fetchData}
                    type="oneToOne"
                    setIsDirtyForm={setIsDirtyForm}
                  />
                  <CommentList
                    data={oneToOneData.comments}
                    user={user}
                    isLineManager={isLineManager}
                    type="comment"
                  />
                </>
              )}
            </Wrapper>
            <InputModal
              show={isInputModalOpen}
              isLineManager={isLineManager}
              close={toggleInputModal}
              confirm={toggleInputModal}
              action={modalAction}
              oneToOneId={oneToOneData._id}
              redirect={`/my-team/${email}`}
            />
            <AreYouSureModal
              show={isAreYouSureModalOpen}
              close={toggleAreYouSureModal}
              confirm={toggleAreYouSureModal}
              action={modalAction}
              selectedId={oneToOneData._id}
              redirect={`/my-team/${email}`}
            />
          </>
        )}
      <AccessDeniedModal show={toggleAccessModal} close={onCloseAccessModal} />
    </>
  );
};

export default withRouter(ViewOneToOne);
